export default "__VITE_ASSET__C6IxNH6e__"